export const ResetIcon = () => (
  <svg width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.33337 5.33325V13.3333H9.33337"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.68004 20C5.54457 22.4539 7.18316 24.5603 9.34892 26.0018C11.5147 27.4434 14.0903 28.1421 16.6877 27.9926C19.285 27.8431 21.7635 26.8536 23.7495 25.173C25.7356 23.4925 27.1217 21.212 27.699 18.6752C28.2763 16.1383 28.0135 13.4826 26.9502 11.1081C25.8869 8.73367 24.0807 6.76907 21.8038 5.51037C19.5269 4.25166 16.9026 3.76703 14.3263 4.1295C11.75 4.49197 9.36126 5.68191 7.52004 7.52001L1.33337 13.3333"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
